import { gql } from '@apollo/client';

export const GET_CURRENT_USER_WITH_SIDE_NAV = gql`
    query CurrentUser{
        currentUser{
            id,
            userName,
            name,
            email,
            contact,
            birthday,
            gender,
            address,
            country,
            state,
            city,
            role{
                name,
                roleSideNavigations{
                    roleType,
                    id,
                    name,
                    icon,
                    order,
                    route,
                    parentId
                }
            }
        }
    }
`

export const FORGOT_PASSWORD = gql`
mutation ForgotPassword($email:String!){
    forgotPassword(email: $email){
        status
    }
}`

export const REGISTER = gql`
mutation SignUp($userName:String!,$password:String!, $clientId:String!){
    signUp(register:{userName: $userName, password: $password, clientId: $clientId}){
        id,
        userName,
        createdAt
    }
}
`

export const CREATE_USER_PROFILE = gql`
mutation CreateUserAccount($displayName:String!, $email:String!){
    createUserAccount(displayName:$displayName, email:$email){
        status
    }
}
`


export const SIGN_IN_MUTATION = gql`
  mutation SignIn($input: SignInInput!) {
    signIn(input: $input) {
      success
      message
      accessToken
      refreshToken
      user {
        id
        name
        email
        userName
        contact
        address
        country
        state
        city
        isActive
        role {
          id
          name
          description
          roleSideNavigations {
            id
            name
            description
            icon
            order
            route
            parentId
            roleType
          }
        }
      }
    }
  }
`;

export const CREATE_USER_MUTATION = gql`
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      success
      message
      accessToken
      refreshToken
      user {
        id
        name
        email
        userName
        contact
        isActive
        role {
          id
          name
          description
          roleSideNavigations {
            id
            name
            description
            icon
            order
            route
            parentId
            roleType
          }
        }
      }
    }
  }
`;

export const CHANGE_PASSWORD_MUTATION = gql`
  mutation ChangePassword($input: ChangePasswordInput!) {
    changePassword(input: $input)
  }
`;

export const REFRESH_TOKEN_MUTATION = gql`
  mutation RefreshToken($refreshToken: String!) {
    refreshToken(refreshToken: $refreshToken) {
      success
      message
      accessToken
      refreshToken
      user {
        id
        name
        email
        userName
        contact
        isActive
        role {
          id
          name
          description
          roleSideNavigations {
            id
            name
            description
            icon
            order
            route
            parentId
            roleType
          }
        }
      }
    }
  }
`;

export const SIGN_OUT_MUTATION = gql`
  mutation SignOut {
    signOut
  }
`;

export const SIGN_UP_MUTATION = gql`
  mutation SignUp($input: SignUpInput!) {
    signUp(input: $input) {
      success
      message
      accessToken
      refreshToken
      user {
        id
        name
        email
        userName
        contact
        isActive
        role {
          id
          name
          description
          roleSideNavigations {
            id
            name
            description
            icon
            order
            route
            parentId
            roleType
          }
        }
      }
    }
  }
`;

export const GET_CURRENT_USER_WITH_SPONSOR_ID = gql`
  mutation GetCurrentUserWithSponsorId($input: GetSponsorInput!) {
    getCurrentUserWithSponsorId(input: $input) {
      success
      message
      sponsor {
        id
        name
      }
    }
  }
`;
